import 'babel-polyfill'
import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routers';
import VueWechatTitle from 'vue-wechat-title';
import 'mint-ui/lib/style.css';
import Mint from 'mint-ui';
import axios from 'axios';
import moment from 'moment/moment'
import es6Promise from 'es6-promise'

es6Promise.polyfill()

Vue.prototype.$http = axios;
Vue.use(Mint);
Vue.use(VueWechatTitle);
Vue.use(VueRouter);

Vue.filter('star',function(value, num) {
    var arr = ["full","half"];
    if(num-value>=0){
        return arr[0];
    }
    if(num%1>0&&Math.ceil(num)==value){
        return arr[1];
    }
});
Vue.filter('dateFormat', function(val, formatStr) {
    return moment(+val).format(formatStr);
});

Vue.filter('filteDistance', function(val) {
    return val>500? Math.round(val/1000 * 100) / 100+'km':val + 'm';
});

import App from './App.vue';

new Vue({
  router: new VueRouter({
    routes
  }),
  render: h => h(App),
}).$mount('#app')
